import { Component, Input } from '@angular/core';
import { BoUploadsModule, UploadComponent as BaseUploadComponent } from '@bo/ng-uploads';
import { AsyncPipe, NgClass } from '@angular/common';
import { NgxUploaderModule } from 'ngx-uploader';
import { AlertModule } from 'ngx-bootstrap/alert';
import { NgbProgressbar, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../loader/loader.component';

@Component({
  selector: 'app-upload',
  imports: [
    BoUploadsModule,
    NgClass,
    NgxUploaderModule,
    AlertModule,
    AsyncPipe,
    NgbProgressbar,
    LoaderComponent,
    NgbTooltip,
  ],
  templateUrl: './upload.component.html',
  styleUrl: '../../../../static/styles/components/file-upload.scss',
})
export class UploadComponent extends BaseUploadComponent {
  @Input() title: string | undefined = 'Drag your file here';
  @Input() text: string = 'or click the button below to upload your file';
  @Input() textExtra: string = '';
  @Input() displaySize: string = ''; // size class
}
